import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { Button, Col, Form, Spinner } from "react-bootstrap";
import AuthLogo from "../components/AuthLogo";
import { swalError, swalSuccess, toastError, toastSuccess } from "../helpers";
import {
  useResendOtpMutation,
  useVerifyOtpMutation,
} from "../app/features/apiSlice";

const VerifyOTP = () => {
  const { t } = useTranslation();
  const { lang, email } = useParams();
  const [otp, setOtp] = useState();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isResendOtp, setIsResendOtp] = useState(false);

  const [verifyOtp] = useVerifyOtpMutation();
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isNaN(otp)) {
      toastError("", "invalidOtp");
      return false;
    }
    setIsLoading(true);
    try {
      const data = { OTP: otp, email, language: lang };
      const response = await verifyOtp(data);
      if (response?.error) {
        swalError(response, t("error.serverNotResponding"));
      } else {
        swalSuccess(response?.data?.message);
        setTimeout(() => {
          navigate(`/${lang}/login`);
        }, 3000);
      }
    } catch (err) {
      swalError(err, t("error.serverNotResponding"));
    }
    setIsLoading(false);
  };

  const [resendOtp] = useResendOtpMutation();
  const handleResendOtp = async () => {
    setIsResendOtp(true);
    try {
      const data = { email, language: lang };
      const response = await resendOtp(data);
      if (response?.error) {
        toastError(response, t("error.serverNotResponding"));
      } else {
        toastSuccess(response?.data?.msg);
      }
    } catch (err) {
      swalError(err, t("error.serverNotResponding"));
    }
    setIsResendOtp(false);
  };

  return (
    <Col lg="4" md="8" sm="12">
      <AuthLogo title="accessHelior" />
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>{t("enterOTP")}</Form.Label>
          <Form.Control
            type="text"
            name="otp"
            onChange={(e) => setOtp(e.target.value)}
            required
          />
        </Form.Group>
        <Button
          variant="primary"
          type="submit"
          className="btn-block btn-primary mt-3 mb-1 py-2"
          disabled={isLoading}
        >
          {t("verifyOtp")}
          {isLoading && <Spinner size="sm" className="ms-2" animation="grow" />}
        </Button>
      </Form>
      <p className="mt-3 text-center">
        <Button
          variant="link"
          className="text-gold"
          onClick={() => handleResendOtp()}
          disabled={isResendOtp}
        >
          {t("resendOtp")}
        </Button>
      </p>
    </Col>
  );
};

export default VerifyOTP;
